'use client';

import { Typography } from '@mui/material';

import { MinimapBg, MinimapStyle } from './styles';
import { MapType } from './types';
import { mapTypeNext } from './utils';
import { publicAssets } from '../../utils';

type Props = {
  mapType: MapType;
  setMapType: (mapType: MapType) => void;
  t: (key: string) => string;
};

export function Minimap({ mapType, setMapType, t }: Props) {
  return (
    <MinimapStyle
      onClick={() => {
        setMapType(mapTypeNext(mapType));
      }}
    >
      <img
        src={publicAssets(`shared/${mapTypeNext(mapType)}.webp`)}
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          zIndex: '1',
          bottom: '0px',
          right: '0px',
        }}
      />
      <MinimapBg style={{ position: 'absolute', zIndex: '2' }} />
      <Typography
        color="#fff"
        sx={{
          position: 'absolute',
          zIndex: '3',
          bottom: '6px',
          paddingX: '11px',
        }}
      >
        {t(`labels.${mapTypeNext(mapType)}`)}
      </Typography>
    </MinimapStyle>
  );
}
